import createIcon from '../../createIcon';

/**
 * @component @name BluetoothConnected
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAxMkw1IDEwTDMgMTJMNSAxNEw3IDEyWk0xNy43MSA3LjcxTDEyIDJIMTFWOS41OUw2LjQxIDVMNSA2LjQxTDEwLjU5IDEyTDUgMTcuNTlMNi40MSAxOUwxMSAxNC40MVYyMkgxMkwxNy43MSAxNi4yOUwxMy40MSAxMkwxNy43MSA3LjcxWk0xMyA1LjgzTDE0Ljg4IDcuNzFMMTMgOS41OVY1LjgzWk0xNC44OCAxNi4yOUwxMyAxOC4xN1YxNC40MUwxNC44OCAxNi4yOVpNMTkgMTBMMTcgMTJMMTkgMTRMMjEgMTJMMTkgMTBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BluetoothConnected = createIcon('BluetoothConnected', [
  [
    'path',
    {
      d: 'M7 12L5 10L3 12L5 14L7 12ZM17.71 7.71L12 2H11V9.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L11 14.41V22H12L17.71 16.29L13.41 12L17.71 7.71ZM13 5.83L14.88 7.71L13 9.59V5.83ZM14.88 16.29L13 18.17V14.41L14.88 16.29ZM19 10L17 12L19 14L21 12L19 10Z',
      key: 'y53yyw',
    },
  ],
]);

export default BluetoothConnected;
